var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmMiniArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#525252",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M284 182c.276 0 .5.224.5.5v7.682l2.679-3.014c.163-.184.43-.219.633-.096l.073.054c.206.184.225.5.041.706l-3.552 4-.014.014c-.015.016-.031.031-.048.045l-.033.024-.041.025-.04.02-.043.015c-.016.006-.031.01-.047.013-.035.008-.07.012-.108.012l.072-.005-.05.005h-.05l-.04-.005c-.016-.002-.03-.004-.044-.008l-.045-.012c-.016-.005-.031-.011-.046-.018l-.033-.016-.05-.031c-.033-.023-.063-.05-.09-.08l.065.062c-.018-.015-.036-.031-.052-.049l-.013-.014-3.5-4c-.182-.208-.161-.523.047-.705.208-.182.523-.161.705.047l2.624 2.998V182.5c0-.245.177-.45.41-.492z",
    transform: "translate(-595 -330) translate(315 148)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmMiniArrow);
export default __webpack_public_path__ + "static/media/atm-mini-arrow.fa060a5995e133b57c2fba964f4ed077.svg";
export { ForwardRef as ReactComponent };